export const permissionsAllowToAll = [
  "allow-to-all",
  "everything-full",
  "everything-readonly",
];
